import { render, staticRenderFns } from "./RoleReference.vue?vue&type=template&id=0d9725e4"
import script from "./RoleReference.vue?vue&type=script&lang=ts"
export * from "./RoleReference.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports